// Furniture in the house follows the room's perspective like people do (2026-10-29): a piece is drawn smaller the
// nearer its bottom edge is to the back wall, by the same rule that sizes her (roomPerspective.mjs), and that bottom
// edge stays where the placement puts it. The saved placement is unchanged — its (x, y) is still the centre of the
// full-size box, which is what the server's floor rule checks — only the drawing is scaled. Wall items hang on the
// wall, not at a depth on the floor, and keep their size; outdoors nothing changes.
// Pure, so `node --test` covers it.
import { perspectiveScale } from './carCatalog.mjs';
import { isFloorItem } from '../scenes/floors.js';

export const HOUSE_ROOMS = new Set(['home', 'kitchen', 'salon', 'second_floor']);

/** The perspective profile a placement is drawn with, or null (full size). */
export function placementProfile(placement, profile) {
  if (!profile || !placement || !HOUSE_ROOMS.has(placement.scene)) return null;
  return isFloorItem(placement.type, placement.item) ? profile : null;
}

/** The drawn box {x, y (centre), w, h, scale} of a full-size box {x, y, w, h} under `profile`. */
export function perspectiveBox({ x, y, w, h }, profile) {
  if (!profile) return { x, y, w, h, scale: 1 };
  const bottom = y + h / 2;
  const scale = perspectiveScale(bottom, profile);
  return { x, y: bottom - (h * scale) / 2, w: w * scale, h: h * scale, scale };
}
